import uniqid from "uniqid";

String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
const Utils = {};

Utils.round = (num, decimals = 100) => {
  return Math.floor(num * decimals) / decimals;
};

Utils.timeSince = (date) => {
  date = new Date(date);
  var seconds = Math.floor((new Date().valueOf() - date.valueOf()) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    if (interval > 2) {
      return Math.floor(interval) + " years";
    } else if (interval >= 1 && interval < 2) {
      return Math.floor(interval) + " year";
    }
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    if (interval > 2) {
      return Math.floor(interval) + " months";
    } else if (interval >= 1 && interval < 2) {
      return Math.floor(interval) + " month";
    }
  }
  interval = seconds / 86400;
  if (interval > 2) {
    return Math.floor(interval) + " days";
  } else if (interval >= 1 && interval < 2) {
    return Math.floor(interval) + " day";
  }

  interval = seconds / 3600;
  if (interval > 1) {
    if (interval > 2) {
      return Math.floor(interval) + " hours";
    } else if (interval >= 1 && interval < 2) {
      return Math.floor(interval) + " hour";
    }
  }
  interval = seconds / 60;
  if (interval > 1) {
    if (interval > 2) {
      return Math.floor(interval) + " minutes";
    } else if (interval >= 1 && interval < 2) {
      return Math.floor(interval) + " minute";
    }
  }
  return "Just now";
  // return Math.floor(seconds) + " seconds";
};

Utils.CustomErrorMessage = (error) => {
  console.log(error);
  if (!error.response) {
    return "Unable to reach server";
  }

  if (error.response.status >= 400 && error.response.status <= 500) {
    return error.response.data.error.toProperCase();
  } else {
    return "Unable to connect to server";
  }
};

Utils.uniqueId = () => {
  return uniqid();
};

const isImage = (type) => {
  const whitelist = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

  if (whitelist.includes(type)) {
    return true;
  }

  return false;
};

Utils.isImage = (file) => {
  const whitelist = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp",
    "image/gif",
  ];
  const allowedExtensions = ["png", "jpeg", "jpg", "webp", "gif"];

  if (whitelist.includes(file.type)) {
    return true;
  }

  // validate file extension
  if (allowedExtensions.includes(file.name.split(".").slice(-1))) {
    return true;
  }

  return false;
};

Utils.isVideo = (file) => {
  const whitelist = ["video/mp4"];
  const allowedExtensions = ["mp4"];

  if (whitelist.includes(file.type)) {
    return true;
  }

  // validate file extension
  if (allowedExtensions.includes(file.name.split(".").slice(-1))) {
    return true;
  }

  return false;
};

Utils.isDocument = (file) => {
  const whitelist = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];
  const allowedExtensions = ["png", "jpeg", "jpg", "pdf"];

  if (whitelist.includes(file.type)) {
    return true;
  }

  // validate file extension
  if (allowedExtensions.includes(file.name.split(".").slice(-1))) {
    return true;
  }

  return false;
};

Utils.detectMediaType = (file) => {
  if (Utils.isImage(file)) {
    return "IMAGE";
  }
  if (Utils.isVideo(file)) {
    return "VIDEO";
  }
  if (Utils.isDocument(file)) {
    return "DOCUMENT";
  }

  return "FILE";
};

export default Utils;
